module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// C:/GH/1106/advice.noa.origination/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 375
// module chunks = 0